<!--
  L'état vide, en une seule implémentation.

  Sur quatorze tableaux du module, trois seulement en avaient un — et chacun
  écrit différemment. Le pire cas était l'écran Qualité : un jeu de données SAIN
  y affichait cinq tableaux vides, strictement indiscernables d'un échec de
  requête. Un tableau vide doit dire s'il est vide parce que tout va bien.
-->
<template>
  <div class="hv2-empty">
    <feather-icon :icon="icon" svgClasses="h-5 w-5" class="hv2-empty-icon" />
    <div>
      <span v-if="title" class="hv2-empty-title">{{ title }}</span>
      <span>{{ text }}</span>
      <div v-if="$slots.default" class="mt-2"><slot /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HvEmpty',
  props: {
    icon: { type: String, default: 'CheckCircleIcon' },
    title: { type: String, default: '' },
    text: { type: String, default: '' }
  }
}
</script>
